module.exports = __webpack_public_path__ + "img/2_1-macerie-0.32b82d73.png";